function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css",
  id: "style824"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", {
  id: "defs827"
}, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_1_",
  d: "M142.8 344.8c-42.1 0-76.3 34.2-76.3 76.3 0 42.1 34.2 76.3 76.3 76.3h63.4L177 468.1c-.3-.3-.6-.7-.9-1-9.4 6.8-20.8 10.8-33.3 10.8-31.3 0-56.8-25.4-56.8-56.8 0-31.3 25.4-56.8 56.8-56.8 31.3 0 56.8 25.4 56.8 56.8 0 12.4-4 23.9-10.8 33.3.4.3.7.5 1 .9l29.3 29.3v-66.8h-.1c-1.7-40.6-35.1-73-76.2-73z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", {
  id: "defs862"
}, /*#__PURE__*/React.createElement("path", {
  id: "SVGID_00000005966191418058645830000003000816493714328961_",
  d: "M-2.3 344.8h600.8v152.6H-2.3z"
}));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    x: 0,
    y: 0,
    xmlSpace: "preserve",
    viewBox: "0 0 600.8 152.6",
    width: "100%",
    height: "100%",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "g1082",
    transform: "translate(2.3 -344.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g859"
  }, _ref3, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070080326181479551180000015401390603043936188_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    },
    id: "use829",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013883532288206514770000010805380939754126988_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.978,
    y1: 844.758,
    x2: 1.978,
    y2: 844.758,
    gradientTransform: "matrix(152.5991 0 0 -152.5991 -82.714 129330.44)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#253081"
    },
    id: "stop832"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#253182"
    },
    id: "stop834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    style: {
      stopColor: "#263382"
    },
    id: "stop836"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.116,
    style: {
      stopColor: "#2d5286"
    },
    id: "stop838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    style: {
      stopColor: "#396d82"
    },
    id: "stop840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338,
    style: {
      stopColor: "#488579"
    },
    id: "stop842"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453,
    style: {
      stopColor: "#57976b"
    },
    id: "stop844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    style: {
      stopColor: "#64a65c"
    },
    id: "stop846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.697,
    style: {
      stopColor: "#6eb04f"
    },
    id: "stop848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    style: {
      stopColor: "#74b646"
    },
    id: "stop850"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    style: {
      stopColor: "#75b843"
    },
    id: "stop852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#75b843"
    },
    id: "stop854"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013883532288206514770000010805380939754126988_)"
    },
    clipPath: "url(#SVGID_00000070080326181479551180000015401390603043936188_)",
    id: "rect857",
    d: "M66.5 344.8h152.6v152.6H66.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g887"
  }, _ref4, /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000067937689333854342780000003494605291736846480_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005966191418058645830000003000816493714328961_",
    style: {
      overflow: "visible"
    },
    id: "use864",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75b843"
    },
    d: "M166.7 437.5c1 .1 1.8.9 1.8 2-.1 1-.9 1.8-2 1.8 0 0-3.7-.1-5.9 2.1-2 2-2.1 4.9-2.1 4.9 0 1-.9 1.8-1.9 1.8-1.1 0-1.9-.9-1.9-1.9 0-.2.1-4.5 3.2-7.5 1-1 2.2-1.8 3.6-2.3-.1-1.4-.6-3.8-2.1-5.3-2-1.9-5.9-2.2-5.9-2.2-1-.1-1.8-1-1.8-2 .1-1 .9-1.8 2-1.8.2 0 5.3.4 8.3 3.2 2.2 2.1 2.9 5 3.2 7.1.9 0 1.5.1 1.5.1m-4.7-18.6c-.8.4-1.6.6-2.4.8.3.8.8 1.7 1.6 2.2 1.3.8 2.8.7 2.8.7 1 0 1.9.7 2 1.8.1 1.1-.7 1.9-1.8 2h-.2c-.8 0-2.7-.1-4.7-1.3-2.2-1.3-3.1-3.7-3.5-5.2-2.8-.3-4.5-1.5-4.6-1.5-.8-.6-1.1-1.8-.5-2.6.6-.8 1.7-1.1 2.6-.5.1.1 3 2 7.1.1 4.8-2.2 4.2-5.6 4.1-6-.1-.5 0-1 .2-1.4.3-.4.7-.7 1.2-.8 1-.2 2 .4 2.3 1.4.6 2.4.1 7.5-6.2 10.3m4.9 10.8c-.4-.4-.7-1-.7-1.6 0-1.3 1.1-2.3 2.3-2.3.3 0 6.6-.1 7.3-4.9.6-3.9-2.2-6-2.3-6.1l-1.7-1.2 1-1.8c.1-.1 1.7-3.4-.9-6.3-2.9-3.4-7.7-2.7-10.7-.3-2 1.6-1.8 4.3-1.8 4.3.1 1.3-.8 2.4-2.1 2.5-1.3.1-2.4-.8-2.5-2.1 0-.2-.5-5.3 3.6-8.4 2.1-1.6 4.5-2.6 7-2.9.2-1 .2-1.8 0-2.3 0-.1-.5-.8-1.9-2 0 0-.1 0-.1-.1-.6-.5-1.7-1.2-2.3-1.3-1.1-.1-2.2.2-3.1.8-.8.6-1 1.2-1 1.3-.3 1.2-1.6 1.9-2.8 1.6-1.2-.3-2-1.6-1.6-2.9.1-.2.6-2.2 2.7-3.8.2-.2.5-.3.8-.5-1.8-.8-4.1-1.5-6.2-1.5-1.9.1-2.3 1.3-2.4 1.9V404c1.5-.6 2.8-.6 3.2-.6h.7c1 .1 1.8 1.2 1.7 2.4 0 1.1-.7 1.9-1.9 2.1h-.3c-.5.1-1.4.1-2.4 1-.4.4-.7 1.1-.9 2.1v24.8c1.6-1.2 3-1.7 4.6-2 .6-.1 1.2 0 1.7.4s.8.9.9 1.5c.2 1.3-.6 2.5-1.9 2.7-.8.1-4.9 1.1-5.4 6v1.4c.1 1.7.7 3.2 1.8 4.5 1.5 1.7 3.7 2.8 6.3 2.9 4.7.2 7.5-4.4 7.5-4.4l.6-.9 1.1-.2s2.4-.4 4.5-2.8 1.3-5.4 1.2-5.5l-.5-1.9 1.7-.9c.3-.2 2.9-1.6 4.1-4.5.5-1.2.2-2.6-.2-3.6-3 1.7-6.1 1.8-7 1.8-.7.1-1.3-.2-1.7-.6m10.7-17.5c1.4 1.5 3.5 4.7 2.8 9.3-.2 1.4-.7 2.7-1.4 3.8.9 1.6 2.5 5.2.9 8.8-1.3 2.9-3.3 4.8-4.9 5.9.2 1.9 0 5.2-2.5 8.1-2.2 2.5-4.8 3.6-6.2 4-1.4 1.8-4.9 5.9-10.5 5.9h-.6c-3.8-.2-7.2-1.8-9.5-4.5-2.2-2.5-3.2-5.8-2.9-9.2V389.4c.2-2 2-5.9 6.9-6h.3c4.7 0 10.2 2.6 13.7 5.1 2.4 1.7 5.5 4.2 6.1 6.4.3 1.1.4 2.4.2 4 2.1.6 4 1.8 5.4 3.5 3.3 3.7 2.8 7.6 2.2 9.8m-42.4 42.3c0 1.6-1.3 2.9-2.9 2.9-1.6 0-2.9-1.3-2.9-2.9v-67.6c0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9zm-11.9-6.7c0 1.6-1.3 2.9-2.9 2.9-1.6 0-2.9-1.3-2.9-2.9v-22.1c0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9zm0-32.2c0 1.6-1.3 2.9-2.9 2.9-1.6 0-2.9-1.3-2.9-2.9v-22.1c0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9zm-10.9 15.9c0 1.6-1.3 2.9-2.9 2.9-1.6 0-2.9-1.3-2.9-2.9v-21.7c0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9zm77.3-10.4c0-25.9-21-46.9-46.9-46.9S96 395.2 96 421.1s21 46.9 46.9 46.9 46.8-21 46.8-46.9",
    clipPath: "url(#SVGID_00000067937689333854342780000003494605291736846480_)",
    id: "path867"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a5ba7"
    },
    d: "M586.7 454.3c8.4 0 11.8-4.7 11.8-11.7v-27c0-1.2-.4-1.6-1.7-1.6h-2.9c-1.2 0-1.7.4-1.7 1.6v19.1c-1.4.4-3.3.7-5.5.7-4 0-5.8-1.7-5.8-5.3v-14.6c0-1.2-.4-1.6-1.7-1.6h-2.9c-1.2 0-1.6.4-1.6 1.6v14.8c0 6.7 3.5 10.7 11.1 10.7 2.7 0 4.8-.4 6.4-.7v2.5c0 3.8-1.9 5.8-5.7 5.8-2.9 0-4.5-1-5.6-2.8-.8-1.1-1.4-1.3-2.7-.6l-2 1.1c-1.2.6-1.4 1.5-.6 2.7 1.9 3.3 5.3 5.3 11.1 5.3m-32.9-12.6h2.9c1.2 0 1.7-.4 1.7-1.7v-19c0-.3.1-.5.5-.7 1.4-.4 3-.6 5.1-.6h1.9c1.2 0 1.6-.4 1.6-1.6v-2.4c0-1.2-.4-1.6-1.6-1.6h-1.8c-4.8 0-8 .9-9.9 1.6-1.7.6-2 1.3-2 3v21.4c0 1.2.4 1.6 1.6 1.6m-11.9 0c1.2 0 1.7-.5 1.7-1.7v-2.5c0-1.2-.4-1.7-1.7-1.7-4.5 0-6.1-.9-6.1-6.1v-9.9h6.1c1.2 0 1.6-.4 1.6-1.7v-2.5c0-1.2-.4-1.6-1.6-1.6h-6.1v-4.8c0-1.2-.4-1.6-1.6-1.6h-2.9c-1.2 0-1.7.4-1.7 1.6v4.8H526c-1.2 0-1.7.4-1.7 1.6v2.5c0 1.2.4 1.7 1.7 1.7h3.6V430c0 9.1 3.3 11.7 12.3 11.7m-35.7.8c7.6 0 11.6-3.7 11.6-8.9 0-6.5-4.5-8-10.9-8.6-4.1-.4-6.3-.8-6.3-3.3 0-1.9 1.5-2.9 5-2.9 3.4 0 4.9 1.2 5.8 2.8.7 1.1 1.1 1.3 2.3.7l2.4-1c1.2-.5 1.5-1.2.9-2.4-1.8-3.5-5.3-5.7-11.4-5.7-7.4 0-11.1 3.5-11.1 8.6 0 6.9 5.6 8.1 10.9 8.6 4.3.4 6.4.9 6.4 3.4 0 2.1-1.9 3.2-5.7 3.2-3.3 0-5.2-.9-6-2.9-.5-1.2-1.1-1.4-2.2-1l-2.4.7c-1.2.4-1.5 1.1-1.1 2.2 1.6 4.2 5.5 6.5 11.8 6.5m-33.9 0c5.1 0 8.3-1 10.5-1.9 1.7-.7 2-1.3 2-3v-22c0-1.2-.4-1.6-1.7-1.6h-2.9c-1.2 0-1.7.4-1.7 1.6v19.7c0 .4-.1.7-.6.9-1.4.4-2.8.6-4.9.6-4 0-5.8-1.7-5.8-5.3v-15.9c0-1.2-.4-1.6-1.7-1.6h-2.9c-1.2 0-1.6.4-1.6 1.6v16.1c.2 6.8 3.7 10.8 11.3 10.8m-33-5.7c-3.8 0-6-1.9-6-5.3v-6.9c0-3.8 2-5.7 6.2-5.7 2.1 0 3.9.4 5.1.7v16.1c0 .3-.1.4-.4.6-1.3.3-3 .5-4.9.5m-.6 5.7c4.9 0 7.9-.9 10-1.7 1.7-.7 2.1-1.2 2.1-2.9v-34c0-1.2-.4-1.7-1.7-1.7h-2.9c-1.2 0-1.7.4-1.7 1.7V414c-1.4-.3-3.7-.7-6.4-.7-7.4 0-11.2 4-11.2 11.2v7.3c.2 6.8 3.9 10.7 11.8 10.7m-43.3-.8h2.9c1.2 0 1.7-.4 1.7-1.7v-19.9c0-.2.1-.4.3-.5 1.4-.4 3.1-.7 5.1-.7 4 0 5.8 1.7 5.8 5.2V440c0 1.2.4 1.7 1.7 1.7h2.9c1.2 0 1.7-.4 1.7-1.7v-16c0-6.8-3.5-10.7-11.1-10.7-5.1 0-8.3 1-10.5 1.8-1.7.7-2 1.3-2 3v22c-.1 1.2.3 1.6 1.5 1.6",
    clipPath: "url(#SVGID_00000067937689333854342780000003494605291736846480_)",
    id: "path869"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75b843"
    },
    d: "M377.4 441.7h3c1.4 0 1.8-.5 1.8-1.8v-34.3c0-1.3-.4-1.8-1.8-1.8h-3c-1.4 0-1.8.5-1.8 1.8v34.3c-.1 1.3.4 1.8 1.8 1.8m-32.8-14 4.1-11.3c1.1-3.3 1.1-6.4 1.1-6.5h.4c0 .1.1 3.2 1.2 6.5l4.1 11.3zm-10.2 14h2.5c2.3 0 2.9-.3 3.3-1.6l2.6-6.9h14.7l2.5 6.9c.4 1.3 1 1.6 3.3 1.6h2.8c1.3 0 1.6-.6 1.2-1.8l-13.4-34.8c-.4-1.2-1-1.4-2.2-1.4h-2.8c-1.2 0-1.8.3-2.2 1.5l-13.3 34.7c-.7 1.2-.3 1.8 1 1.8",
    clipPath: "url(#SVGID_00000067937689333854342780000003494605291736846480_)",
    id: "path871"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#75b843",
      strokeWidth: 0.524
    },
    d: "M377.4 441.7h3c1.4 0 1.8-.5 1.8-1.8v-34.3c0-1.3-.4-1.8-1.8-1.8h-3c-1.4 0-1.8.5-1.8 1.8v34.3c-.1 1.3.4 1.8 1.8 1.8zm-32.8-14 4.1-11.3c1.1-3.3 1.1-6.4 1.1-6.5h.4c0 .1.1 3.2 1.2 6.5l4.1 11.3zm-10.2 14h2.5c2.3 0 2.9-.3 3.3-1.6l2.6-6.9h14.7l2.5 6.9c.4 1.3 1 1.6 3.3 1.6h2.8c1.3 0 1.6-.6 1.2-1.8l-13.4-34.8c-.4-1.2-1-1.4-2.2-1.4h-2.8c-1.2 0-1.8.3-2.2 1.5l-13.3 34.7c-.7 1.2-.3 1.8 1 1.8z",
    clipPath: "url(#SVGID_00000067937689333854342780000003494605291736846480_)",
    id: "path873"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a5ba7"
    },
    d: "M324.3 441.7c1.2 0 1.7-.5 1.7-1.7v-2.5c0-1.2-.4-1.7-1.7-1.7-4.5 0-6.1-.9-6.1-6.1v-9.9h6.1c1.2 0 1.6-.4 1.6-1.7v-2.5c0-1.2-.4-1.6-1.6-1.6h-6.1v-4.8c0-1.2-.4-1.6-1.6-1.6h-2.9c-1.2 0-1.7.4-1.7 1.6v4.8h-3.6c-1.2 0-1.7.4-1.7 1.6v2.5c0 1.2.4 1.7 1.7 1.7h3.6V430c.1 9.1 3.3 11.7 12.3 11.7m-36-4.3c-4.2 0-5-1.4-5-3.6s1.1-3.6 5.1-3.6c2.1 0 4.8.2 5.8.3v5.7c0 .5-.2.6-.6.7-.9.3-2.6.5-5.3.5m.6 5.1c4.4 0 7.6-.5 9.6-1.4 1.5-.6 1.9-1.2 1.9-3v-13.8c0-6.3-2.6-11-11.4-11-5.6 0-9.2 2.1-11.1 5.6-.6 1.2-.3 1.9.9 2.4l2.2.9c1.2.5 1.5.3 2.2-.8 1.2-1.7 2.9-2.6 5.6-2.6 4.1 0 5.3 2 5.3 5.3v1.6c-.9-.1-3-.3-5.1-.3-8.6 0-12.1 2.1-12.1 8.5.1 5.5 2.5 8.6 12 8.6m-32.6-5.7c-3.8 0-6-1.9-6-5.3v-6.9c0-3.8 2-5.7 6.2-5.7 2.1 0 3.9.4 5.1.7v16.1c0 .3-.1.4-.4.6-1.4.3-3 .5-4.9.5m-.6 5.7c4.9 0 7.9-.9 10-1.7 1.7-.7 2.1-1.2 2.1-2.9v-34c0-1.2-.4-1.7-1.7-1.7h-2.9c-1.2 0-1.7.4-1.7 1.7V414c-1.4-.3-3.7-.7-6.4-.7-7.4 0-11.2 4-11.2 11.2v7.3c.2 6.8 3.9 10.7 11.8 10.7",
    clipPath: "url(#SVGID_00000067937689333854342780000003494605291736846480_)",
    id: "path875"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a5ba7"
    },
    d: "M40.9 457.6c-1.5 0-2.7-1.3-2.7-3v-67.9c0-1.6 1.2-3 2.7-3 1.5 0 2.7 1.3 2.7 3v67.9c0 1.7-1.2 3-2.7 3",
    clipPath: "url(#SVGID_00000067937689333854342780000003494605291736846480_)",
    id: "path877"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a5ba7"
    },
    d: "M27.4 457.6c-1.5 0-2.7-1.3-2.7-3v-44.5c0-1.6 1.2-3 2.7-3 1.5 0 2.7 1.3 2.7 3v44.5c0 1.7-1.2 3-2.7 3",
    clipPath: "url(#SVGID_00000067937689333854342780000003494605291736846480_)",
    id: "path879"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a5ba7"
    },
    d: "M.3 457.6c-1.5 0-2.7-1.3-2.7-3v-26.9c0-1.6 1.2-3 2.7-3 1.5 0 2.7 1.3 2.7 3v26.9c0 1.7-1.2 3-2.7 3",
    clipPath: "url(#SVGID_00000067937689333854342780000003494605291736846480_)",
    id: "path881"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a5ba7"
    },
    d: "M54.4 457.6c-1.5 0-2.7-1.3-2.7-3v-58.8c0-1.6 1.2-3 2.7-3 1.5 0 2.7 1.3 2.7 3v58.8c0 1.7-1.2 3-2.7 3",
    clipPath: "url(#SVGID_00000067937689333854342780000003494605291736846480_)",
    id: "path883"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3a5ba7"
    },
    d: "M13.9 457.6c-1.5 0-2.7-1.3-2.7-3v-58.8c0-1.6 1.2-3 2.7-3 1.5 0 2.7 1.3 2.7 3v58.8c0 1.7-1.2 3-2.7 3",
    clipPath: "url(#SVGID_00000067937689333854342780000003494605291736846480_)",
    id: "path885"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.0162c4f4.svg";
export { ForwardRef as ReactComponent };